module.exports = __webpack_public_path__ + "static/img/04.41da896.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/04.jpg
// module id = 399
// module chunks = 1